
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static notGreaterThan(maxDate: Date): (control: AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      if( !control.value ){
        return null;
      }
      const dateValue = new Date(control.value);
      return dateValue > maxDate? { notLessThanMaxDate: true } : null;
    };
  }
}
